import { useTranslation } from 'react-i18next';
import {
  useInterventionBulkCloseMutation,
  useInterventionDestroyMutation,
  useInterventionUpdateMutation,
} from 'graphql-common';
import { showGraphQLErrors } from '@lib/utils/graphQLErrors';

export default function useMutations() {
  const { t } = useTranslation();

  const [interventionDestroyMutation, interventionDestroyMutationResult] =
    useInterventionDestroyMutation({
      onError: (error) => showGraphQLErrors(error, t),
    });

  const [interventionBulkCloseMutation, interventionBulkCloseMutationResult] =
    useInterventionBulkCloseMutation({
      onError: (error) => showGraphQLErrors(error, t),
    });

  const [interventionUpdateMutation, interventionUpdateMutationResult] =
    useInterventionUpdateMutation({
      onError: (error) => showGraphQLErrors(error, t),
    });

  return {
    interventionBulkCloseMutation,
    interventionBulkCloseMutationResult,
    interventionDestroyMutation,
    interventionDestroyMutationResult,
    interventionUpdateMutation,
    interventionUpdateMutationResult,
  };
}
